import { useMemo } from 'react';

import { Select } from '@cast/design-system';

import { defaultOption, resolvedCriterion } from '../constants';

import { useSearchCriterion, Criterion } from '@cast/shared-search-ui';

const options: Criterion[] = [
  defaultOption,
  { key: 'resolved', title: 'Resolved' },
  { key: 'obsolete', title: 'Obsolete' },
  { key: 'all', title: 'All' },
];

export const ResolvedDropdown = () => {
  const { value: _value, setValue } = useSearchCriterion(resolvedCriterion);

  const value = useMemo(
    () => options.find((item) => item.key === _value),
    [_value]
  );

  return (
    <Select
      startAdornment="Show:"
      value={value}
      options={options}
      optionLabel={(item) => item.title!}
      optionKey={(item) => item.key}
      onChange={(newValue) => {
        if (newValue === value) {
          setValue?.('all');
        } else {
          setValue?.(newValue.key);
        }
      }}
      testId="resolved-dropdown"
    />
  );
};
